module.exports = __webpack_public_path__ + "img/dollars-saved.0e6f4c42.svg";